import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Table, ProductModal, Loader, SectionTitle } from '../components';
import { fetchRemovedItems, fetchSingleProduct } from '../redux/actions';
import { truncate } from '../utils';

const rows = [
  { field: '_id', title: 'ID' },
  { field: 'orderId', title: 'Order ID' },
  { field: 'itemRemoved', title: 'Removed Items' },
];

const columns = (arr, setProductId) => {
  return arr.map((i) => ({
    _id: truncate(i._id, 10),
    orderId: i._id,
    itemRemoved: itemRemoved(i.itemsRemoved, setProductId),
  }));
};

const itemRemoved = (items, setProductId) => (
  <ul role="list" className="rounded-md divide-y divide-gray-200">
    {items.map((i) => (
      <li
        key={i._id}
        className="py-2 flex justify-between text-sm divide-gray-200"
      >
        <div className="mr-3">
          <span className="">{i.productName}</span>
        </div>
        <div className="">
          <button
            className="text-xs text-sky-600 hover:text-sky-500"
            onClick={() => setProductId(i.productId)}
          >
            View Product
          </button>
        </div>
      </li>
    ))}
  </ul>
);

const prodFreq = (items) => {
  if (items) {
    const arr = items
      .map((i) => i.itemsRemoved)
      .flat()
      .reduce((acc, i) => {
        acc[i.productName] = acc[i.productName] + 1 || 1;
        return acc;
      }, {});
    return Object.entries(arr).map((i, ind) => ({
      product: i[0],
      frequency: i[1],
      _id: ind,
    }));
  }
};

export default function ViewRemovedItems() {
  const [openModal, setOpenModal] = useState(false);
  const [productId, setProductId] = useState(null);
  const [product, setProduct] = useState(null);

  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.removedItems);

  useEffect(() => {
    dispatch(fetchRemovedItems());
  }, []);

  useEffect(() => {
    if (productId) {
      fetchSingleProduct(productId).then((res) => setProduct(res));
      setOpenModal(true);
    }
  }, [productId]);

  return (
    <section className="mt-6 px-6">
      {items ? (
        <>
          <div className="mb-3">
            <SectionTitle label="Removed items before checkout" />
          </div>
          <Table
            rows={rows}
            columns={items?.length > 0 ? columns(items, setProductId) : []}
          />

          <div className="mt-3">
            <SectionTitle label="Items Frequency" />
          </div>
          <Table
            rows={[
              { field: 'product', title: 'Product' },
              { field: 'frequency', title: 'Frequency' },
            ]}
            columns={items?.length > 0 ? prodFreq(items) : []}
          />
          {productId && product && (
            <ProductModal
              open={openModal}
              setOpen={setOpenModal}
              product={product}
              disableCart
              handleClose={() => setProduct(null)}
            />
          )}
        </>
      ) : (
        <Loader />
      )}
    </section>
  );
}
